import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notAvailableMessage: {
		id: 'work-management-board.board-old.column-old.transition-zones.not-available-message',
		defaultMessage: 'A workflow rule prevents you from moving the issue this way.',
		description: 'message for when the drop zone is restricted',
	},
	transitionNotAvailableMessage: {
		id: 'work-management-board.board-old.column-old.transition-zones.transition-not-available-message',
		defaultMessage:
			"You can't move this issue to this column due to workflow configurations or permissions.",
		description:
			'Message to show in board column when there are no applicable transitions for the card being dragged',
	},
	transitionUnavailableMessage: {
		id: 'work-management-board.board-old.column-old.transition-zones.transition-unavailable-message',
		defaultMessage: 'Unable to move this item to this column due to workflow restrictions',
		description:
			'Message to show in board column when there are no applicable transitions for the card in drag',
	},
});
